import { logger } from '@/lib/logger';

export const logLookup = (
  eligibility: boolean,
  type: 'guest' | 'member',
): void => {
  logger.fpti('billing_guest_login_otp_eligibility_called', {
    cust_type: type,
    eligibility,
    event_name: 'billing_guest_login_otp_eligibility_called',
    product: 'billing',
    state_name: 'billing_otp_eligible',
    transition_name: 'process_billing_otp_eligible',
  });
};
